import { Star, Quote } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { Reveal, ChapterTag, SectionTitle } from "./Reveal";

export function Testimonials() {
  const { content } = useSite();
  const items = content?.testimonials || [];
  if (!items.length) return null;

  return (
    <section id="testimoni" data-testid="testimonials-section" className="relative py-24 sm:py-32 bg-navy-950">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <ChapterTag number="09" label="Testimoni" />
        <div className="mb-14">
          <SectionTitle>Apa Kata <span className="text-ice">Pelanggan Kami?</span></SectionTitle>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((t, i) => (
            <Reveal key={t.id || i} delay={0.06 * (i % 3)}>
              <figure data-testid={`testimonial-card-${i}`} className="h-full bg-navy-900 border border-glacier/15 rounded-sm p-7 flex flex-col hover:border-ice/40 transition-colors duration-300">
                <Quote className="w-7 h-7 text-ice/50" />
                <blockquote className="mt-4 text-sm text-frost/90 leading-relaxed flex-1">"{t.text}"</blockquote>
                <div className="mt-5 flex items-center gap-1" data-testid={`testimonial-rating-${i}`}>
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className={`w-4 h-4 ${s < (t.rating || 0) ? "text-ice fill-ice" : "text-navy-800"}`} />
                  ))}
                </div>
                <figcaption className="mt-4 pt-4 border-t border-glacier/15 flex items-center gap-3">
                  {t.avatar ? (
                    <img src={t.avatar} alt={t.name} loading="lazy" className="w-10 h-10 rounded-full object-cover" />
                  ) : (
                    <span className="w-10 h-10 rounded-full bg-navy-800 border border-glacier/25 flex items-center justify-center font-display text-lg font-bold text-ice">
                      {(t.name || "?").replace(/[[\]]/g, "").charAt(0)}
                    </span>
                  )}
                  <div>
                    <p className="text-sm font-semibold text-frost">{t.name}</p>
                    <p className="text-xs text-steel">{t.company}{t.project ? ` — ${t.project}` : ""}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
